import { envVar } from '@babylon/babylon-env'

const ENVIRONMENT = envVar('ENVIRONMENT') || 'Unknown'
const SENTRY_URL = envVar('SENTRY_URL')

export { SENTRY_URL, ENVIRONMENT }
